import { userDashboardPaymentMethodsAddCardRoute } from '#/modules/userDashboard/routing/userDashboard.routes';
import type { HorizonAppRouteLoaderArgs } from '#/routing/classes/types/AppRouteLoaderArgs';
import type { HorizonAppRouteComponentProps } from '#/routing/types/HorizonAppRouteComponentProps';

import { AddPaymentMethodPageContainerLoadable } from './AddPaymentMethodPageContainerLoadable';

export async function loader(
  _: HorizonAppRouteLoaderArgs<typeof userDashboardPaymentMethodsAddCardRoute>,
) {
  await AddPaymentMethodPageContainerLoadable.load();
}

export default function UserDashboardAddPaymentMethodHorizonRoute(
  _: HorizonAppRouteComponentProps<typeof loader>,
) {
  return <AddPaymentMethodPageContainerLoadable />;
}
